import { BaseApi } from "../base";

interface IAccountIntroAdminAppFlagsDataDto {
  helpDeskIntegrationModalSeen: string | null; // date-time
}

export interface IAccountIntroFlagsDataDto {
  data: { adminApp: IAccountIntroAdminAppFlagsDataDto };
}

type IntroFlags = "helpDeskIntegrationModalSeen";

export type IUpdateIntroFlagsPayload = Array<IntroFlags>;

const commonHeaders = { "x-application-type": "HelpDeskAdminApp" } as const;

export default class KnowledgeBaseApi extends BaseApi {
  protected readonly service = "knowledgebase";

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchIntroFlags = () => this.get("api/account/intro-flags", undefined, { ...commonHeaders });
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateIntroFlags = (payload: IUpdateIntroFlagsPayload) =>
    this.patch("api/account/intro-flags", { adminApp: payload }, { ...commonHeaders });
}
